export default {
  getParticipantsByProperties: (state) => (property, value) => {
    return state.participantsList.filter((item) => {
      return item.properties[property][0] === value;
    });
  },
};
